import FurnishingTabRefund from "./furnishing-tab-refund";
import FurnishingTabStorage from "./furnishing-tab-storage";

const FurnishingTabs = {
    Storage : FurnishingTabStorage,
    Refund : FurnishingTabRefund
}

export default FurnishingTabs;
